import script from "./UploadMedia.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadMedia.vue?vue&type=script&setup=true&lang=js"

import "./UploadMedia.vue?vue&type=style&index=0&id=3d113fb1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d113fb1"]])

export default __exports__